export function getScrollbarWidth(element){return window.innerWidth-(element||document.documentElement).clientWidth}export default getScrollbarWidth;